// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FamilyPoints_wrapper__2InjP","title":"FamilyPoints_title__1r4SK","points":"FamilyPoints_points__X4FE5","reward":"FamilyPoints_reward__1_7-M"};